import { TSupplier } from "components/supplier/helpers/supplier-types-helper";

export const enum EOrganizerStatus
{
    ACTIVE = "active",
    CLOSED = "closed",
}

export type TOrganizer = {
    id: string;
    title: string;
    logo_path: string;
    et_default_id: string;
    status: EOrganizerStatus;
    total_stands: number | null;
    total_equipment: number | null;
    total_floorings: number | null;
    suppliers: TSupplier[];
};

export interface IFilter {
    column: string;
    operator: string;
    value: string[];
    AND?: IFilter[];
}
